const baseUrl = process.env.VUE_APP_API_BASE_URL.replace('/api/v1', '');

export default function filterfortable(header, value) {
    if (header === 'icon') {
        return !value.includes(baseUrl) ? baseUrl + value : value;
    }
    if (header === 'price') {
        return Number (value).toFixed(2);
    }

    return value;
}